module.exports = __webpack_public_path__ + "static/swimming-1ca41849b48c2ddf607939d564fd2d98.jpg";